import moment from 'moment'

export function canGenerateOverduePix (dueDate, today = new Date()) {
  const date = moment(String(dueDate || '').split(/[ T]/)[0], ['YYYY-MM-DD', 'DD/MM/YYYY'], true)

  return date.isValid() && moment(today).startOf('day').diff(date.startOf('day'), 'days') > 60
}
